import React, { useState } from "react";
import { useResetPasswordMutation } from "./Myaccountapislice";

const ResetPassword = ({ onClose }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [errorr, setErrorr] = useState("");
  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [resetPassword, { isLoading, isSuccess, isError, error }] =
    useResetPasswordMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedForm = {
        ...prev,
        [name]: value,
      };

      // Check if the passwords don't match (only when both fields have values)
      if (
        (name === "newPassword" || name === "confirmPassword") &&
        updatedForm.newPassword &&
        updatedForm.confirmPassword &&
        updatedForm.newPassword !== updatedForm.confirmPassword
      ) {
        setErrorr("Passwords do not match");
      } else {
        setErrorr("");
      }

      return updatedForm;
    });
  };

  const handleSubmit = async () => {
    try {
      await resetPassword(formData).unwrap();
      // Keep the success message visible
      setTimeout(() => {
        setIsOpen(false);
        onClose();
      }, 2000); // 2 seconds delay
    } catch (err) {
      console.error("Password update failed:", err);
    }
  };

  return (
    isOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-96 relative">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          >
            ✕
          </button>
          {/* Icon */}
          <div className="w-16 h-16 bg-blue-950 text-white flex justify-center items-center rounded-full mx-auto -mt-10 shadow-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="w-8 h-8"
            >
              <path d="M10 0a5 5 0 00-5 5v3H4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2h-1V5a5 5 0 00-5-5zM8 5a2 2 0 014 0v3H8V5zm-4 6h12v8H4v-8z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold mt-4 text-blue-950 text-center">
            Reset Password
          </h2>
          {/* Input Fields */}
          <div className="mt-4">
            <label className="block text-gray-700 font-medium">
              Old Password
            </label>
            <input
              type="password"
              name="oldPassword"
              placeholder="Enter your old  password"
              value={formData.oldPassword}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mt-4">
            <label className="block text-gray-700 font-medium">
              New Password
            </label>
            <input
              type="password"
              name="newPassword"
              placeholder="Enter new password"
              value={formData.newPassword}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errorr && <p style={{ color: "red" }}>{errorr}</p>}
          </div>
          <div className="mt-4">
            <label className="block text-gray-700 font-medium">
              Confirm Password
            </label>
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm new password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          {/* Error handle message */}
          {isError && (
            <div className="mt-2 text-red-600 text-sm">
              {error.message || "something went wrong"}
            </div>
          )}
          {/* Success Message */}
          {isSuccess && (
            <div className="mt-2 text-green-600 text-sm">
              Password updated successfully
            </div>
          )}
          {/* Buttons */}
          <div className="flex justify-between mt-6">
            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className="bg-blue-950 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              {isLoading ? "Updating" : "Update Password"}
            </button>
            <button
              onClick={onClose}
              className="text-gray-600 hover:text-gray-800"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ResetPassword;
